import { Injectable } from '@angular/core';
import { from, Observable, switchMap, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

export interface ApiError {
  code: string;
  message: string;
  description?: string;
  status?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  public handleError(errorResp: HttpErrorResponse): Observable<never> {

    console.log('HTTP error:', errorResp);

    if (errorResp.error instanceof Blob) {

      return from(errorResp.error.text()).pipe(
        switchMap(text => {
          let body;

          try {
            body = JSON.parse(text);
          } catch {
            return throwError(() => ({
              code: 'UNKNOWN_ERROR',
              message: text,
              status: errorResp.status
            }));
          }

          return throwError(() => ({
            code: body.error ?? body.code ?? 'ERROR',
            message: body.error_description ?? body.message ?? 'Unexpected error',
            status: errorResp.status
          }));
        })
      );
    }

    // Structured error body from the backend
    if (errorResp.error && typeof errorResp.error === 'object') {
      return throwError(() => ({
        code: errorResp.error.code ?? errorResp.error.error ?? 'ERROR',
        message: errorResp.error.error_description ?? errorResp.error.message ?? errorResp.message ?? 'Unexpected error',
        description: errorResp.error.error_description ?? errorResp.error.description,
        status: errorResp.status
      }));
    }

    return throwError(() => ({
      code: 'UNKNOWN_ERROR',
      message: errorResp.message,
      status: errorResp.status
    }));
  }
}
